export const FAQConstants = {
    GETFAQ_REQUEST : 'GETFAQ_REQUEST',
    GETFAQ_SUCCESS : 'GETFAQ_SUCCESS',
    GETFAQ_FAILURE : 'GETFAQ_FAILURE'
}


// WEBPACK FOOTER //
// ./src/store/constants/faqs.constants.js